import { render } from "./ProductsVue.vue?vue&type=template&id=b337308e"
import script from "./ProductsVue.vue?vue&type=script&lang=js"
export * from "./ProductsVue.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__